import { SynthProfile } from '.';
const routes = [
    {
        path: '/synth-profile',
        element: <SynthProfile />,
        title: 'Synth Profile'
    }
]

export default routes;